import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempSlittingService {
  // private apiUrl = "http://localhost:3003/api/tempSlitting";
   private apiUrl = "https://lexipackghana.com:3003/api/tempSlitting";

  constructor(private http: HttpClient) {}
  addTempSlitting(data:any){
    return this.http.post(this.apiUrl+'/addTempSlitting',data);
  }
  getTempSlitting(){
    return this.http.get(this.apiUrl+'/getAllTempSlitting');
  }
  getTempSlittingById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempSlitting(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}
